import { connect } from 'react-redux';
import HealthStatus from './HealthStatus';
import {
    allMetrix,
    metrixLoading,
} from "../../../store/selectors/projects.selector";
import {
    updateStatusKPI,
    getMetrics,
} from "../../../store/actions/projects.actions";

const mapDispatchToProps = { updateStatusKPI, getMetrics };

const mapStateToProps = (state) => {
    const metrixList = allMetrix(state);
    const loading = metrixLoading(state);
    return { metrixList, loading };
};

export default connect(mapStateToProps, mapDispatchToProps)(HealthStatus);
